import { Subject } from 'rxjs';
import { Vaccination } from './../../auth/_models/vaccination';
import { Vaccine } from './../../auth/_models/vaccine';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { PetsService } from 'src/app/auth/_services/pets.service';
import { Pet } from 'src/app/auth/_models/pet';
import { VaccineService } from 'src/app/auth/_services/vaccine.service';

declare let CustomScript: any;

@Component({
  selector: 'app-pet-detail-vaccine',
  templateUrl: './pet-detail-vaccine.component.html',
  styleUrls: ['./pet-detail-vaccine.component.css'],
  providers: [VaccineService]
})
export class PetDetailVaccineComponent implements OnInit, AfterViewInit, OnDestroy {
  vaccinations: Array<Vaccination> = [];
  isVaccine;
  vaccineFound = false;
  uuid: string;
  pet: Pet;
  unsub;

  constructor(
    private _route: ActivatedRoute,
    private _vaccineService: VaccineService,
  ) {
    this.unsub = new Subject();
  }

  ngAfterViewInit(): void {
    CustomScript.initSwitchery();
    CustomScript.initDatatableAdvanced(
      {
        targets: 6
      }
    );
  }

  // teste(event, uuid) {
  //   console.log(uuid, event.target.checked);
  // }

  ngOnInit() {
    this._route.parent.params.subscribe(params => {
      const id = this.uuid = params['id'];
      this._vaccineService.getPetVaccination(id)
        .subscribe(vaccinations => {
          if (vaccinations.length >= 1) {
            this.vaccinations = vaccinations;
            this.vaccineFound = true;
          } else {
            this.vaccineFound = false;
          }
        });
    });
  }

  ngOnDestroy() {
    this.unsub.next();
    this.unsub.complete();
  }

  alertText(v: Vaccination) {
    if (typeof v.alert !== 'undefined' && v.alert) {
      if (v.alerttype === 'email') {
        return 'Lembrar por e-mail';
      } else {
        return 'Lembrar por telefone';
      }
    } else {
      return '---';
    }

  }
}
